export const parsePriceRub = (raw) => {
  const s = String(raw || "").replace(/[^\d]/g, "");
  return parseInt(s, 10) || 0;
};

export const formatPriceRub = (n) => Number(n || 0).toLocaleString("ru-RU");
